import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

const Button = styled.span`
  background: white;
  box-sizing: border-box;
  border-radius: 6px;
  color: ${themeGet('colors.primary.100')};
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 24px;
  padding: 8px;
  border: 1px solid ${themeGet('colors.border')};

  &:hover {
    border-color: ${themeGet('colors.black.80')};
    color: ${themeGet('colors.primary.100')};
    background: ${themeGet('colors.white')};
  }
`;

export const BackToPlanButton = ({ onClick }) => {
  return (
    <li>
      <Button onClick={onClick}>Back To Plan</Button>
    </li>
  );
};
